<template>
  <div v-if="isActive">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useTab } from '~/composables';
import { computed } from 'vue';

interface Props {
  name: string;
  text?: string;
  link?: string | any;
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
  link: '',
});
const tab = computed(() => ({
  name: props.name,
  text: props.text || props.name,
  link: props.link,
}));

const { isActive } = useTab(tab as any);
</script>
